import * as React from 'react';
import { ANIM_STATE } from '@/components/MultiSkuModalGolden/constant';
import { MultiSkuStore } from '@/components/MultiSkuModalGolden/Store';
import '@/components/MultiSkuModalGolden/Components/BottomToast/index.css';
import { FullDiscountExtraInfo } from '@/src/pages/shop/c_shop_golden/component';

const SLCommon = Mach.requireModule('SLCommon');

interface IProps {
  fullDiscountExtraInfo: FullDiscountExtraInfo;
  subTitle?: string;
}
export default class BottomToast extends React.Component<IProps, any> {
  toastRef: any;
  toastState: string = ANIM_STATE.END;
  store: MultiSkuStore = new MultiSkuStore();
  // submit button 54   discount tip 36
  bottomPosition = 12 + 54 + 36 + this.store.getScreenBottom() - 1

  constructor(props) {
    super(props);
    this.state = {
      toastVisible: false
    };
  }

  animationTemp =(keyFrames: any, duration: number = 200) => ({
    duration: `${duration}ms`,
    iterationCount: 1,
    direction: 'normal',
    timingFunction: 'ease-in-out',
    fillMode: 'forward',
    transformOrigin: 'left top',
    delay: '0s',
    keyFrames
  })

  toastShow = () => {
    if (this.toastState !== ANIM_STATE.END) {
      return;
    }
    // ----- mpweb适配origin -----
    // ----- mpweb适配change -----
    this.toastRef.style.zIndex = 1;
    // ----- mpweb适配       -----
    const keyFrames = {
      from: { opacity: 0 },
      to: { opacity: 1 },
    };
    const animToastShow = this.animationTemp(keyFrames);
    this.toastRef.setAnimation(animToastShow, (callback) => {
      if (callback.state === 'start') {
        this.toastState = ANIM_STATE.START;
      } else if (callback.state === 'end') {
        this.setState({
          toastVisible: true
        });
      }
    });
  }

  toastHidden = () => {
    if (!this.state.toastVisible) {
      return;
    }
    const keyFrames = {
      from: { opacity: 1 },
      to: { opacity: 0 },
    };

    const animToastHidden = this.animationTemp(keyFrames);
    this.toastRef?.setAnimation(animToastHidden, (callback) => {
      if (callback.state === 'end') {
        this.setState({
          toastVisible: false
        });
        this.toastState = ANIM_STATE.END;
      }
    });
    // ----- mpweb适配origin -----
    // ----- mpweb适配change -----
    this.toastRef.style.zIndex = 0;
    // ----- mpweb适配       -----
  }

  getTextWidth(content: string) {
    return SLCommon.widthForText({
      content,
      fontSize: 12,
      fontFamily: 'KeeTa-Regular'
    });
  }

  getToastPosition() {
    const { fullDiscountExtraInfo: { fullDiscountTips = '', fullDiscountToast = '' } = {} } = this.props;
    const tipTextWidth = this.getTextWidth(fullDiscountTips);
    // 给5%的余量 计算宽度与实际渲染宽度并不符合 与设计沟通暂定3%buffer
    const toastTextWidth = this.getTextWidth(fullDiscountToast) * 1.03;
    // left border + left padding + icon + text(左右4边距) + icon / 2
    const middlePosition = (2 + 16) + 12 + (4 + tipTextWidth + 4) + 12 / 2;
    const screenWidth = Mach.env.screenWidth;
    const screenLineWidth = Mach.env.screenWidth - 18 * 2 - 10 * 2;
    // 尽量能一行放下 所以在文字长度不超过屏幕宽度时，优先调整两侧边距使得文字可以放下
    const isLeftOfCenter = middlePosition < screenWidth / 2;
    const shortMarginPosition = Math.max(18, Math.floor(middlePosition - toastTextWidth / 2 - 10));
    const longMarginPosition = Math.max(18, Math.floor(screenWidth - (shortMarginPosition + 10 + toastTextWidth + 10)));
    return {
      middle: middlePosition,
      left: isLeftOfCenter ? shortMarginPosition : longMarginPosition,
      right: isLeftOfCenter ? longMarginPosition : shortMarginPosition
    };
  }

  render() {
    const { fullDiscountExtraInfo: { fullDiscountToast = '' } = {} } = this.props;
    const { middle, left, right } = this.getToastPosition();
    return (
      <view
        className="bottom-toast"
        ref={(ref: any) => { this.toastRef = ref; }}
      >
        { this.state.toastVisible && (
          <view className="bottom-toast-mask" onClick={this.toastHidden} />
        )}
        <view className="bottom-toast-content" style={{ bottom: this.bottomPosition }}>
          <text content={fullDiscountToast} className="bottom-toast-title" />
        </view>
        <image className="bottom-toast-arrow" src="assets://shop/modal_toast_arrow.png" style={{ bottom: this.bottomPosition - 7, left: middle - 10 }} resizeMode="aspectFit" />
      </view>
    );
  }
}
